var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('data-title',{attrs:{"title":"居住地"}}),_c('div',{staticClass:"graph"},[_c('img',{staticClass:"image",attrs:{"src":require("images/Event/Infographics/area@2x.png"),"active":_vm.show}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }